/*
 * @author: Razvan Rauta
 * Date: 08/04/2021
 * Time: 12:00
*/

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  subtitle: {
    padding: '8px 24px 8px',
  },
  listItemText: {
    fontSize: 14,
  },
  listItemRoot: {
    margin: 0,
  },

  errorMessage: {
    padding: '8px 24px 8px',
    fontSize: 15,
    color: 'red',
  },
  dialogRoot: {
    '&.MuiDialog-scrollPaper': {
      alignItems: 'flex-end',
      padding: 0,
      margin: 0,
    },
  },
  paper: {
    '&.MuiPaper-root': {
      margin: 0,
      maxWidth: '100%',
      width: '100%',
      padding: '20px 16px',
      '& .MuiDialogContent-root': {
        padding: 0,
      },
    },
  },
  roleMenuItem: {
    '& .menu-item__root': {
      display: 'flex',
      paddingLeft: '2px',
    },
  },
  closeButton: {
    position: 'absolute',
    top: 24,
    right: 16,
    padding: 0,
  },
});

export default useStyles;
